<div class="bg-white p-5">
  <!-- TITLE + ORG -->
  <h2 class="text-2xl font-bold text-dc-navy mb-2">
    {{ serviceData?.serviceName }}
  </h2>

  <!-- DESCRIPTION -->
  @if (serviceData?.serviceDetail?.description) {
  <p class="text-sm text-dc-navy! mb-6">
    {{ serviceData.serviceDetail.description }}
  </p>
  }


  <!-- Other Details -->
  @if (serviceData?.serviceDetail?.otherDetail) {
  <div class="">
    <p class="text-dc-navy! mt-4 mb-4">{{serviceData?.serviceDetail?.otherDetail.greeting}}</p>
    <p class="text-dc-navy! mt-4 mb-4">{{serviceData?.serviceDetail?.otherDetail.intro}}</p>
  </div>
  <h2 class="text-lg font-bold text-dc-navy mb-3">
    {{ serviceData?.serviceDetail?.otherDetail?.titile }}
  </h2>
 @if (serviceData?.serviceDetail.otherDetail.list?.length > 0) { @for (item of
  serviceData?.serviceDetail.otherDetail.list; track item) {
  <ul class="list-disc ms-6 text-sm text-dc-navy mt-4 mb-6">
    <li class="text-sm text-dc-navy mb-4">
      <span [innerHTML]="item.title"></span>
    </li>
    <!-- @if(item.documents && item.documents?.length > 0) {
    <li class="list-none">
      <ul class="list-decimal ms-6 text-sm text-dc-black mb-6">
        @for (document of item.documents; track document; let i = $index) {
        <li class="text-sm text-dc-black mb-4">{{ document.title }}</li>

        }
      </ul>
    </li>
    } -->
  </ul>
  } } }


  
  <!-- PROCESSING TIME + FEES NOTE BOX -->
  @if (serviceData?.serviceDetail?.processingTime ||
  serviceData?.serviceDetail?.feesNote) {
  <div class="border-2 text-base border-dc-navy p-6 mb-8 lg:w-[30%]">
    @if (serviceData?.serviceDetail?.feesNote) {
    <div class="text-dc-navy font-semibold text-base mb-1 w-full">
      {{ "SR_DETAIL.FEES" | translate }}
      {{ serviceData.serviceDetail.feesNote }}
    </div>
    } @if (serviceData?.serviceDetail?.processingTime) {
    <div class="text-dc-navy text-base w-full">
      {{ "SR_DETAIL.PROCESSING_TIME" | translate }}
      {{ serviceData.serviceDetail.processingTime }}
    </div>
    }
  </div>
  }

  <!-- START SERVICE BUTTON -->
  <div class="mt-6 mb-5">
    <app-button
      class="block w-full sm:w-auto"
      classesName="btn-edge-cut w-full sm:w-auto"
      [label]="'SR_DETAIL.BTN_START' | translate"
      (onBtnClick)="startService()"
    >
    </app-button>
  </div>
  <hr class="mb-5" />

  <!-- 1. SERVICE PROCEDURE / STEPS -->
  @if (serviceData?.serviceProcedure?.length > 0) {
  <h2 class="text-lg font-bold text-dc-navy mb-4">
    {{ "SR_DETAIL.STEPS_TITLE" | translate }}
  </h2>

  @for (step of serviceData.serviceProcedure; track step; let i = $index) {
  <div class="flex gap-4 mb-6">
    <!-- number & line -->
    <div class="flex flex-col items-center shrink-0">
      <span
        class="w-6 h-6 rounded-full bg-dc-navy text-white flex items-center justify-center text-xs font-bold"
      >
        {{ i + 1 }}
      </span>
      @if (i < serviceData.serviceProcedure.length - 1) {
      <span class="flex-1 w-px bg-gray-300"></span>
      }
    </div>
    <!-- text -->
    <div>
      <span class="font-semibold text-base text-dc-navy block w-full">
        {{ step.title }}
      </span>

      @if (step.description) {
      <span class="text-sm text-dc-black mt-1 block w-full">
        {{ step.description }}
      </span>
      }
    </div>
  </div>
  } }

  <!-- 2. BENEFICIARIES -->
  <!-- @if (serviceData?.Beneficiaries?.length > 0) {
  <h2 class="text-lg font-bold text-dc-navy mb-3">
    {{ "Beneficiaries" | translate }}
  </h2>

  @for (b of serviceData.Beneficiaries; track b) { @if (b.title) {
  <p class="font-semibold text-dc-navy mb-1">
    {{ b.title }}
  </p>
  } @if (b.description) {
  <p class="text-sm text-dc-black mb-4">
    {{ b.description }}
  </p>
  } } } -->

  <!-- 3. SERVICE REQUIREMENTS DOCUMENTS-->
  @if (serviceData?.serviceRequirements) {
  @for (requirement of requirementSections; track $index) {
  <h2 class="text-lg font-bold text-dc-navy mb-3">
    {{
      requirement.heading
        ? requirement.heading
        : ("SR_DETAIL.REQ_TITLE" | translate)
    }}
  </h2>

  @if (requirement.title) {
  <span class="font-semibold text-sm text-dc-black block w-full">
    {{ requirement.title }}
  </span>
  } @if (requirement.list?.length > 0) { @for (item of
  requirement.list; track item) {
  <ul class="list-disc ms-6 text-sm text-dc-black mt-4 mb-6">
    <li class="text-sm font-semibold text-dc-black mb-4">{{ item.title }}</li>
    @if(item.documents && item.documents?.length > 0) {
    <li class="list-none">
      <ul class="list-decimal ms-6 text-sm text-dc-black mb-6">
        @for (document of item.documents; track document; let i = $index) {
        <li class="text-sm text-dc-black mb-4">{{ document.title }}</li>

        }
      </ul>
    </li>
    }
  </ul>
  <!-- <p class="text-sm text-dc-black mb-4">
    {{ item.description }}
  </p> -->
  } }
  @if ($index > 0 && requirement.note) {
    <p class="text-sm text-dc-black mb-6">{{ requirement.note }}</p>
  }
  } }

  <!-- 4. SERVICE FEES -->
  @if (serviceData?.serviceFees?.length > 0) {
  <h2 class="text-lg font-bold text-dc-navy mb-4">
    {{ "SR_DETAIL.FEES_TITLE" | translate }}
  </h2>

  @for (fee of serviceData.serviceFees; track fee) { @if (fee.title) {
  <span class="font-semibold text-sm text-dc-black block w-full mb-4">
    {{ fee.title }}
  </span>
  } @if (fee.list?.length > 0) {
  <ul class="list-disc ms-6 text-sm text-dc-black mt-4 mb-6">
    @for (line of fee.list; track line) {
    <li class="text-sm text-dc-black mb-4">
      {{ line }}
    </li>
    }
  </ul>
  } } }

  <!-- 5. HOW TO APPLY -->
  <!-- @if (serviceData?.howToApply?.length > 0) {
  <h2 class="text-lg font-bold text-dc-navy mb-4">
    {{ "SR_DETAIL.APPLY_TITLE" | translate }}
  </h2>

  <ul class="list-decimal ms-6 text-sm text-dc-black mb-6">
    @for (line of serviceData.howToApply; track line) {
    <li class="mb-2">
      {{ line }}
    </li>
    }
  </ul>
  } -->

  <!-- 6. ADDITIONAL INFORMATION -->
  <!-- @if (serviceData?.additionalInformation) {
  <h2 class="text-lg font-bold text-dc-navy mb-4">
    {{ "Additional information" | translate }}
  </h2>

  @if (serviceData.additionalInformation.otherChannels) {
  <p class="text-sm text-dc-black mb-2">
    <span class="font-semibold">{{ "Other channels: " | translate }}</span>
    {{ serviceData.additionalInformation.otherChannels }}
  </p>
  } @if (serviceData.additionalInformation.contact) {
  <p class="text-sm text-dc-black mb-2">
    <span class="font-semibold">{{ "Contact: " | translate }}</span>
    {{ serviceData.additionalInformation.contact }}
  </p>
  } @if (serviceData.additionalInformation.location) {
  <p class="text-sm text-dc-black mb-4">
    <span class="font-semibold">{{ "Location: " | translate }}</span>
    {{ serviceData.additionalInformation.location }}
  </p>
  } } -->

  <!-- 7. RESOURCES -->
  <!-- @if (serviceData?.resources?.length > 0) {
  <h2 class="text-lg font-bold text-dc-navy mb-4">
    {{ "SR_DETAIL.RES_TITLE" | translate }}
  </h2>

  <ul class="space-y-4 mb-4">
    @for (res of serviceData.resources; track res) {
    <li>
      <a
        class="text-dc-blue underline"
        [href]="res.url"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ res.title }}
      </a>
    </li>
    }
  </ul>
  } -->

  <section class="mt-10">
    <h2 class="text-xl font-bold text-dc-navy mb-6">
      {{ "SR_DETAIL.APPLY.ADDITIONAL_INFORMATION" | translate }}
    </h2>

    <div class="space-y-6 text-sm text-dc-black">
      <!-- Other ways to apply -->
      <div>
        <span class="font-semibold text-sm text-dc-black block w-full">
          {{ "SR_DETAIL.APPLY.WAYS_HEAD" | translate }}
        </span>
        <span class="text-sm text-dc-black block w-full">
          {{ "SR_DETAIL.APPLY.WAYS_TEXT" | translate }}
          <!-- Dubai chamber mobile app: Download Dubai chamber application on your
          mobile and login with your credentials. Look for the service you want
          to apply for and start application process. Or scan the QR code below
          to open the service on your mobile. -->
        </span>
        <div class="mt-4 flex gap-4">
            <img src="images/andriod-app.png" [alt]="'SR_DETAIL.APPLY.QR_ALT' | translate"
              class="w-52 h-52" width="208" height="208" />

              <img src="images/ios-app.png" [alt]="'SR_DETAIL.APPLY.QR_ALT' | translate"
              class="w-52 h-52" width="208" height="208" />
        </div>
      </div>

      <!-- Help desk -->
      <!-- <div>
        <span class="font-semibold text-sm text-dc-black block w-full">
          {{ "SR_DETAIL.APPLY.HELP_HEAD" | translate }}
        </span>
        <span class="text-sm text-dc-black block w-full">
          {{ "SR_DETAIL.APPLY.HELP_TEXT" | translate }}
        </span>
      </div> -->

      <!-- Sector -->
      <div>
        <span class="font-semibold text-sm text-dc-black block w-full">
          {{ "SR_DETAIL.APPLY.SECTOR" | translate }}
        </span>
        <span class="text-sm text-dc-black block w-full">
          {{ "SR_DETAIL.APPLY.BUSINESS" | translate }}</span
        >
      </div>

      <!-- Service type -->
      <div>
        <span class="font-semibold text-sm text-dc-black block w-full">
          {{ "SR_DETAIL.APPLY.TYPE" | translate }}
        </span>
        <span class="text-sm text-dc-black block w-full">
          {{ "SR_DETAIL.APPLY.SUB_SERVICE_TRANSACTIONAL" | translate }}</span
        >
      </div>

      <!-- Characteristics -->
      <!-- <div>
        <p class="font-semibold text-dc-navy">{{"SR_DETAIL.APPLY.CHAR" | translate}}</p>
        <p>Characteristic 1</p>
        <p>Characteristic 2</p>
      </div> -->

      <!-- Total transactions -->
      <!-- <div>
        <p class="font-semibold text-dc-navy">Total transactions</p>
        <p>42866</p>
      </div> -->

      <!-- SDG Goals -->
      <!-- <div>
        <p class="font-semibold text-dc-navy">SDG Goals</p>
        <p>Goal 1: Poverty</p>
      </div> -->
    </div>
  </section>

  <!--how to apply -->
  <!-- <section class="mt-14">
    <h2 class="text-xl font-bold text-dc-navy mb-6">How To Apply</h2>

    <div class="space-y-6 text-sm text-dc-black">
      <div>
        <p class="font-semibold text-dc-navy mb-1">Other ways to apply</p>
        <p>
          Dubai chamber mobile app: Download Dubai chamber application on your
          mobile and login with your credentials...
        </p>
      </div>

      <div>
        <p class="font-semibold text-dc-navy mb-1">Dubai chambers help desk:</p>
        <p>
          Book an appointment by calling +0412312312, visit Dubai chamber office
          at the preferred time slot. Location
        </p>
      </div>

      <div>
        <p class="font-semibold text-dc-navy">Sector</p>
        <p>Business</p>
      </div>

      <div>
        <p class="font-semibold text-dc-navy">Service type</p>
        <p>Sub service - Transactional</p>
      </div>

      <div>
        <p class="font-semibold text-dc-navy">Service characteristics</p>
        <p>Characteristic 1</p>
        <p>Characteristic 2</p>
      </div>

      <div>
        <p class="font-semibold text-dc-navy">Total transactions</p>
        <p>42866</p>
      </div>

      <div>
        <p class="font-semibold text-dc-navy">SDG Goals</p>
        <p>Goal 1: Poverty</p>
      </div>
    </div>
  </section> -->

  <!-- service manual -->
  <section class="mt-14 lg:w-[30%]">
    <app-validation-message
      type="default"
      [content]="{
        title: 'SR_DETAIL.RES_MANUAL_BOX.HEAD' | translate,
        message: 'SR_DETAIL.RES_MANUAL_BOX.TEXT' | translate
      }"
      [showbutton]="false"
      [buttonText]="'SR_DETAIL.RES_MANUAL_BOX.LINK' | translate"
      (onBtnClick)="gotoServiceManuals()"
    />
  </section>

  <!-- Resoure list -->
  @if (serviceData?.resources?.length > 0) {
  <section class="mt-14">
    <h2 class="text-xl font-bold text-dc-navy mb-6">
      {{ "SR_DETAIL.RES_TITLE" | translate }}
    </h2>
    <ul class="space-y-5 text-sm text-dc-black">
      @for (res of serviceData.resources; track res) {
      <li>
        <a
          [href]="res.url"
          target="_blank"
          class="text-dc-dark-blue font-semibold underline underline-offset-4"
          >{{ res.title }}</a
        >
        <!-- <p class="text-xs text-gray-500">Size : 640kb</p> -->
      </li>
      }
    </ul>
  </section>
  }

  <!-- terms and condition -->
  <!-- <section class="mt-14 mb-20">
    <h2 class="text-xl font-bold text-dc-navy mb-6">Terms and Conditions</h2>

    <p class="text-sm text-dc-black leading-6">
      To become a member, simply visit this page and fill out the membership
      application form. Our team will guide you through the process and provide
      assistance as needed.
    </p>
  </section> -->
</div>
